import { render, staticRenderFns } from "./OnsiteSearchGroupResultItem.vue?vue&type=template&id=85ef0c98&"
import script from "./OnsiteSearchGroupResultItem.vue?vue&type=script&lang=ts&"
export * from "./OnsiteSearchGroupResultItem.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports